/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { AuthResult } from './authResult'
import type { ChallengePasswordOutPutAllOf } from './challengePasswordOutPutAllOf'

export type ChallengePasswordOutPut = AuthResult & ChallengePasswordOutPutAllOf
